module.exports = __webpack_public_path__ + "img/news03-M02.a196fbf4.jpg";